module.exports = __webpack_public_path__ + "img/square.60f9d016.svg";